<template>
  <div class="profile">
    <div class="header" v-if="profile!=null">
      <img class="header-icon" src="../assets/head.png" />
      <div class="header-title">
        <p class="ent-name">{{profile.name}}</p>
        <p class="telephone">
          {{profile.telephone}}
          <span class="status audit" v-if="profile.status==1">未审核</span>
          <span class="status nopass" v-if="profile.status==2">审核未通过</span>
          <span class="status passed" v-if="profile.status==9">已审核</span>
        </p>
      </div>
      <div class="summary">
        <div class="summary-item">
          <div class="summary-num">{{profile.codeTotal||0}}</div>
          <div class="summary-title">溯源码总数</div>
        </div>
        <div class="summary-item">
          <div class="summary-num">{{profile.codeUsed||0}}</div>
          <div class="summary-title">已使用</div>
        </div>
        <div class="summary-item">
          <div class="summary-num">{{profile.downLimit||"暂无服务"}}</div>
          <div class="summary-title">下载服务期限</div>
        </div>
        <div class="summary-item">
          <div class="summary-num">{{profile.queryLimit||"暂无服务"}}</div>
          <div class="summary-title">查询服务期限</div>
        </div>
      </div>
    </div>

    <mt-cell title="修改信息" is-link to="/ent/edit">
      <svg slot="icon" t="1579577628544" class="mint-cell-icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1341" width="20" height="20"><path d="M892.4 315.9c-17.5 0-31.8 14.2-31.8 31.8v517h-699V165.6h501.7c17.5 0 31.8-14.2 31.8-31.8S680.8 102 663.3 102H161.6c-35 0-63.6 28.5-63.6 63.6v699.1c0 35 28.5 63.6 63.6 63.6h699.1c35 0 63.6-28.5 63.6-63.6v-517c-0.1-17.6-14.3-31.8-31.9-31.8z" fill="#8a8a8a" p-id="1342"></path><path d="M926 98.7c-14.9-14.9-39-14.9-53.9 0l-337 337c-14.9 14.9-14.9 39 0 53.9 7.4 7.4 17.2 11.2 27 11.2s19.5-3.7 27-11.2l337-337c14.8-14.8 14.8-39-0.1-53.9zM244.4 704.1c0 17.5 14.2 31.8 31.8 31.8h349.5c17.5 0 31.8-14.2 31.8-31.8 0-17.5-14.2-31.8-31.8-31.8H276.1c-17.5 0.1-31.7 14.3-31.7 31.8z" fill="#8a8a8a" p-id="1343"></path><path d="M736.9 704.1m-31.8 0a31.8 31.8 0 1 0 63.6 0 31.8 31.8 0 1 0-63.6 0Z" fill="#8a8a8a" p-id="1344"></path></svg>
    </mt-cell>
    <mt-cell title="修改密码" is-link to="/user/pwd">
      <svg slot="icon" t="1579577595833" class="mint-cell-icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1123" width="20" height="20"><path d="M812.5 384.6H328.9v-58.3c0-92.7 75.4-168.1 168.1-168.1h30.2c67.3 0 127.9 40.2 154.6 102.3 8.5 19.8 13 40.8 13.5 62.4 0.3 16.3 13.7 29.4 29.9 29.4h0.6c16.5-0.3 29.7-14 29.4-30.6-0.6-29.4-6.7-57.9-18.3-84.9-36.1-84.2-118.4-138.6-209.7-138.6H497c-125.8 0-228.1 102.3-228.1 228.1v58.3h-54c-33 0-59.9 26.9-59.9 59.9v423.8c0 33 26.9 59.9 59.9 59.9h597.6c33 0 59.9-26.9 59.9-59.9V444.6c0-33.1-26.9-60-59.9-60z m0 483.8H214.9V444.6h597.6v423.8z" fill="#8a8a8a" p-id="1124"></path><path d="M527.1 827.4c44.7 0 86.9-17.2 118.8-48.5 11.8-11.6 12-30.6 0.4-42.4-11.6-11.8-30.6-12-42.4-0.4-20.6 20.2-47.9 31.4-76.8 31.4-60.5 0-109.8-49.3-109.8-109.8s49.3-109.8 109.8-109.8c43.7 0 83.2 25.9 100.7 65.9 6.6 15.2 24.3 22.1 39.5 15.5 15.2-6.6 22.1-24.3 15.5-39.5C655.7 528 594.6 488 527.1 488c-93.6 0-169.7 76.1-169.7 169.7s76.1 169.7 169.7 169.7z" fill="#8a8a8a" p-id="1125"></path><path d="M663.8 688.6m-30 0a30 30 0 1 0 60 0 30 30 0 1 0-60 0Z" fill="#8a8a8a" p-id="1126"></path></svg>
    </mt-cell>
    <mt-cell title="联系我们">
      <svg slot="icon" t="1579577575758" class="mint-cell-icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6216" width="20" height="20"><path d="M979.84 404.544L574.272 84c-34.912-27.648-89.696-27.616-124.576 0L44.16 404.544c-13.856 10.976-16.224 31.104-5.28 44.96s30.624 16.224 44.48 5.28L96 444.416V832c0 54.944 57.888 96 108.8 96h640c50.304 0 83.2-38.592 83.2-96V445.92l11.68 8.864c5.888 4.64 13.12 6.88 20.064 6.88 9.44 0 18.912-4.16 25.216-12.16 10.976-13.856 8.768-33.984-5.12-44.96zM480 864V686.592c0-8.832 16-13.248 32-13.248s32 4.416 32 13.248V864h-64z m384-32c0 21.216-5.856 32-19.2 32H608.64c0-0.48-0.64-0.864-0.64-1.344V686.592c0-37.216-30.016-77.28-96-77.28s-96 40.064-96 77.28v176.064c0 0.48 0.864 0.864 0.864 1.344H204.8c-20.064 0-44.8-17.344-44.8-32V393.824l328.928-259.616c11.808-9.344 33.12-9.344 44.96 0L864 395.328V832z" fill="#8a8a8a" p-id="6217"></path></svg>
      <span style="font-size:0.8rem;line-height:1.5em;display:inline-block;">成都市双林路388号富临大厦1802室</span>
    </mt-cell>
    <mt-cell title="联系电话">
      <svg slot="icon" t="1579577550465" class="mint-cell-icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4847" width="20" height="20"><path d="M832 762.24 832 768c0 96.64-83.84 176-192 189.44L640 928c0-17.92-14.08-32-32-32l-128 0C462.08 896 448 910.08 448 928l0 64C448 1009.92 462.08 1024 480 1024l128 0c159.36 0 288-114.56 288-256l0-5.76" p-id="4848" fill="#8a8a8a"></path><path d="M896 762.24c37.12-13.44 64-48.64 64-90.24l0-128c0-41.6-26.88-76.8-64-90.24L896 448c0-211.84-172.16-384-384-384C300.16 64 128 236.16 128 448l0 5.76C90.88 467.2 64 502.4 64 544l0 128C64 725.12 106.88 768 160 768S256 725.12 256 672l0-128c0-41.6-26.88-76.8-64-90.24L192 448c0-176.64 143.36-320 320-320 176.64 0 320 143.36 320 320l0 5.76c-37.12 13.44-64 48.64-64 90.24l0 128c0 41.6 26.88 76.8 64 90.24M192 672C192 689.92 177.92 704 160 704S128 689.92 128 672l0-128C128 526.08 142.08 512 160 512S192 526.08 192 544L192 672zM896 672c0 17.92-14.08 32-32 32S832 689.92 832 672l0-128C832 526.08 846.08 512 864 512S896 526.08 896 544L896 672z" p-id="4849" fill="#8a8a8a"></path></svg>
      028-84403882 13438025008
    </mt-cell>

    <div style="padding: 2rem 1rem 0;">
      <mt-button type="danger" size="large" @click.native="logout">退出登录</mt-button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapState } from "vuex";

export default {
  computed: mapState({
    profile: state => state.userData
  }),
  methods: {
    logout() {
      this.$router.push("/login");
    },
    getProfile() {
      var $app = this;
      this.$http
        .get(this.GLOBAL.serverUrl + "/ent/profile")
        .then(function(resp) {
          if (resp.body.code == 200) {
            this.$store.commit("setUserData", resp.body.data);
            if (resp.body.data.status == 2) {
              MessageBox.alert(
                "您的注册信息审核未通过，请修改信息后重新提交！"
              ).then(function() {
                $app.$router.push("/ent/edit");
              });
            }
          }
        });
    }
  },
  mounted(){
    if (this.profile == null) {
      this.getProfile();
    }
  }
};
</script>
<style scoped>
.profile {
  font-size: 14px;
}
.header {
  padding-top: 1rem;
  border-bottom: 5px #f0f0f0 solid;
  background: #ffffff;
}
.header-icon {
  width: 3rem;
  height: 3rem;
  float: left;
  margin-left: 3rem;
}
.header-title {
  font-weight: bold;
  padding: 0.5rem 0 0 1rem;
  display: inline-block;
}
.header-title p {
  padding: 0;
  margin: 0;
  line-height: 1.5rem;
}
.header-title p.telephone .status {
  font-size: 0.7rem;
  padding: 2px;
}
.header-title p.telephone .status.nopass {
  color: red;
  background: #dfdfdf;
}
.header-title p.telephone .status.passed {
  color: green;
  background: #dfdfdf;
}
.header-title p.telephone .status.audit {
  color: #999999;
  background: #dfdfdf;
}
.header-title p.telephone {
  color: #666666;
}
.summary {
  padding-top: 1rem;
}
.summary-item {
  width: 50%;
  display: inline-block;
  height: 3rem;
  text-align: center;
  padding-bottom: 1rem;
}
.summary-num {
  font-size: 1.3em;
  font-weight: bold;
  color: black;
  line-height: 2rem;
}
.mint-cell-icon {
  margin: 0 0.5rem;
  float: left;
  width: 1.2rem;
  height: 1.2rem;
}
</style>